import type { Course } from "@/api";

type PricedCourse = Pick<Course, "priceType" | "priceUzs" | "discountPriceUzs"> & {
  discountEndDate?: string | null;
};

export interface CoursePrice {
  isFree: boolean;
  /** Ro'yxat narxi (butun so'm). */
  price: number;
  /** HOZIR to'lanadigan narx — checkout aynan shuni oladi. */
  effective: number;
  /** Eski narx chizib ko'rsatiladimi. */
  hasDiscount: boolean;
  percentOff: number;
  /** Chegirma tugaydigan lahza (ISO) — muddatsiz yoki chegirmasiz bo'lsa `null`. */
  discountEndsAt: string | null;
}

/**
 * Kursning HOZIRGI narxi — backenddagi `effectivePriceUzs` ning ko'zgusi.
 *
 * Panel ilgari faqat ro'yxat narxini ko'rsatardi: 690 000 so'mlik kurs
 * chegirmada 490 000 ga sotilayotganini moderator ham, admin ham
 * bilmasdi. Chegirma faqat ijobiy va MUDDATI O'TMAGAN bo'lsa amal qiladi
 * (`discountEndDate === null` — muddatsiz).
 *
 * @param now solishtirish payti (epoch ms) — testda qotirish uchun.
 */
export const coursePrice = (course: PricedCourse, now: number = Date.now()): CoursePrice => {
  const price = course.priceUzs;
  const discount = course.discountPriceUzs;
  const endsAt = course.discountEndDate ?? null;
  const active = discount !== null && discount > 0 && (endsAt === null || Date.parse(endsAt) > now);
  const hasDiscount = active && discount < price;

  return {
    isFree: course.priceType === "FREE",
    price,
    effective: active ? discount : price,
    hasDiscount,
    percentOff: hasDiscount ? Math.round((1 - discount / price) * 100) : 0,
    discountEndsAt: hasDiscount ? endsAt : null,
  };
};
